import { render, staticRenderFns } from "./PublisherTemplate.vue?vue&type=template&id=4faa8f53&scoped=true&"
import script from "./PublisherTemplate.vue?vue&type=script&lang=js&"
export * from "./PublisherTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa8f53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4faa8f53')) {
      api.createRecord('4faa8f53', component.options)
    } else {
      api.reload('4faa8f53', component.options)
    }
    module.hot.accept("./PublisherTemplate.vue?vue&type=template&id=4faa8f53&scoped=true&", function () {
      api.rerender('4faa8f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/PublisherTemplate.vue"
export default component.exports